import { render, staticRenderFns } from "./UserReport.vue?vue&type=template&id=aec70a06&scoped=true&"
import script from "./UserReport.vue?vue&type=script&lang=js&"
export * from "./UserReport.vue?vue&type=script&lang=js&"
import style0 from "./UserReport.vue?vue&type=style&index=0&id=aec70a06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec70a06",
  null
  
)

export default component.exports